import React, { useEffect, useState, useRef} from 'react';
import Button from '@mui/material/Button';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export default function ProductView() {
    const navigate = useNavigate()
    const { GetProductById } = useServiceContext();
      const { id } = useParams();
     const didFetch = useRef(false); 
    const [data, setData] = useState(null);
    const userType = localStorage.getItem('userType');
      const getData = async () => {
        
          try {
            const d = await GetProductById(id);
                setData(d);
          
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleEdit = () => {
        navigate(`/viewproduct/${data.productId}/true`);
    }

    useEffect(() => {       
        if (!didFetch.current) {
          getData();    
            didFetch.current = true;
        }
      });

    return (
       <div>  {didFetch.current && data && <main id="main" className="main">
            <div className="pagetitle">
            <h1>Product</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/products">Products</a></li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Product Details</h5>
                                <div className="container">
                                    <div className="row mb-3">
                                        <nav className="navbar navbar-expand-lg navbar-light">
                                            <div className="container-fluid">
                                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                    </ul>{(userType==="PARTNER" || userType==="ADMIN") &&
                                                        <Button className="right-button"
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={handleEdit} >
                                                            Edit
                                                        </Button>}
                                                </div>
                                            </div>
                                        </nav>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                          <strong>Name:</strong> <span className="ms-2">{data.productName}</span>
                                        </div>
                                        <div className="col-md-6">
                                          <strong>Category Id:</strong> <span className="ms-2">{data.categoryId}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                          <strong>Manufacturer:</strong> <span className="ms-2">{data.manufacturer}</span>
                                        </div>
                                        <div className="col-md-6">
                                          <strong>Model:</strong> <span className="ms-2">{data.model}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                          <strong>Year:</strong> <span className="ms-2">{data.year}</span>
                                        </div>
                                        <div className="col-md-6">
                                          <strong>Price:</strong> <span className="ms-2">{data.price}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                          <strong>Branch:</strong> <span className="ms-2">{data.branchName || data.branchId}</span>
                                        </div>
                                        <div className="col-md-6">
                                          <strong>Quantity In Stock:</strong> <span className="ms-2">{data.quantityInStock}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                          <strong>Change Frequency (KM):</strong> <span className="ms-2">{data.reorderLevel}</span>
                                        </div>
                                        <div className="col-md-6">
                                          <strong>In Stock:</strong> <span className="ms-2">{data.inStock !== false ? 'Yes' : 'No'}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                          <strong>Quick Select:</strong> <span className="ms-2">{data.isQuickSelect === true ? 'Yes' : 'No'}</span>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>}</div>
    );
}
